<template>
    <div class="d-flex justify-content-start mb-4">
        <core-basic-drop-down
            class="input-group px-0 col-sm-2"
            :items="priceRuleTypes"
            :selection.sync="selectedRuleType"
            noLabel
            :simple-value="false"
            :labelAttribute="labelAttribute"
        ></core-basic-drop-down>
        <div class="input-group col-sm-1 pl-4 pr-4"></div>
        <div
            v-if="selectedRuleType.code !== 'LASTMINUTE' && selectedRuleType !== '12'"
            class="input-group col-sm-1 px-0 number-input align-items-center d-flex"
        >
            <img @click="stepDownMin()" src="@/assets/svg/minus-767676.svg">
            <input v-model="initialAmountMin" type="number" class="mb-0">
            <img @click="stepUpMin()"  src="@/assets/svg/plus-767676.svg">
        </div>
        <div
            v-else
            class="input-group col-sm-1 px-0 number-input align-items-center d-flex"
        >
            <img @click="stepDownMax()" src="@/assets/svg/minus-767676.svg">
            <input v-model="initialAmountMax" type="number" class="mb-0">
            <img @click="stepUpMax()"  src="@/assets/svg/plus-767676.svg">
        </div>
        <div
            class="col-sm-1"
        >
            {{ $t('components.price.element.offer-types.nights') }}
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      selectedRuleType: this.type,
      initialAmountMin: this.amountMin,
      initialAmountMax: this.amountMax,
      priceRuleTypes: this.$store.getters.priceRuleTypes
    }
  },
  props: {
    type: {
      default: null,
      type: String | Number,
      required: false
    },
    amountMin: {
      default: 0,
      type: String | Number,
      required: false
    },
    amountMax: {
      default: 0,
      type: String | Number,
      required: false
    },
    section: {
      default: null,
      type: String,
      required: false
    }
  },
  computed: {
    labelAttribute () {
      return 'name_' + this.$i18n.locale.toUpperCase()
    }
  },
  created () {
    switch (this.section) {
      case 'offers':
        let offerTypes = [
          'ALTERNATENIGHTS',
          'BOOKDATE',
          'LASTMINUTE',
          'LONGSTAY'
        ]
        this.priceRuleTypes = []
        console.log(offerTypes)
        offerTypes.forEach((offerType) => {
          let found = this.$_.find(this.$store.getters.priceRuleTypes, {'code': offerType})
          if (found) {
            this.priceRuleTypes.push(found)
            console.log(found)
          }
        })
        break

      default:
        this.priceRuleTypes = this.$store.getters.priceRuleTypes
    }
  },
  methods: {
    stepUpMin () {
      this.initialAmountMin++
    },
    stepDownMin () {
      this.initialAmountMin--
    },
    stepUpMax () {
      this.initialAmountMax++
    },
    stepDownMax () {
      this.initialAmountMax--
    }
  },
  watch: {
    selectedRuleType (val) {
      this.$emit('update:type', val)
    },
    initialAmountMin (val) {
      this.$emit('update:amount-min', val)
    },
    initialAmountMax (val) {
      this.$emit('update:amount-max', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/price/element/OfferTypes.vue